var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text_align_btn",class:("text_align_" + _vm.direction + "_btn"),on:{"click":function($event){return _vm.alignText(_vm.direction)}}},[_c('inline-svg',{attrs:{"src":_vm.alignIcon,"fill":"#737373"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }